import { useEffect } from 'react';

const APP_NAME = 'Baluarte CRM';

/**
 * Sets `document.title` to "<title> · Baluarte CRM" while the calling
 * component is mounted, restoring the previous title on unmount.
 */
export function useDocumentTitle(title: string | undefined | null): void {
  useEffect(() => {
    const previous = document.title;
    if (title) {
      document.title = `${title} · ${APP_NAME}`;
    } else {
      document.title = APP_NAME;
    }
    return () => { document.title = previous; };
  }, [title]);
}
